import axios from 'axios';

export default {
    getGuidancePacksForOrg(tenantId, orgId) {
        return axios.get(window.API_BASE + '/api/v1/' + tenantId + '/Orgs/' + orgId + '/GuidancePacks');
    }
}